import {FETCH_SUGGESTION_CATEGORIES_REQUEST, FETCH_SUGGESTION_CATEGORIES_SUCCESS, FETCH_SUGGESTION_CATEGORIES_FAILURE} from './suggestionCategoryTypes'

const initialState = {
    loading: true,
    data: [],
    errorMsg: '',
  };
  
  const suggestionCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SUGGESTION_CATEGORIES_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_SUGGESTION_CATEGORIES_SUCCESS:
        return {
          ...state,
          loading: false,
          data: action.payload,
          errorMsg: '',
        };
      case FETCH_SUGGESTION_CATEGORIES_FAILURE:
        return {
          ...state,
          loading: false,
          data: [],
          errorMsg: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default suggestionCategoriesReducer;